export default function(fetch: GlobalFetch) {
  return async function(values: any) {
    const response = await fetch.fetch(`/api/v2/worker/create`, {
      method: 'POST',
      body: JSON.stringify({ ...values }),
    })

    const json = await response.json()

    if ('error' in json) {
      throw new Error(json.messages[0])
    }

    return json
  }
}
